// The asset list's IoT columns (removed entirely for semiconductor users, see
// industryColumns.ts).
export const IOT_COLUMN_FIELDS = [
    "firmwareVersion",
    "modemFirmwareVersion",
    "iotHubConnectivity",
    "slaStatus",
    "slaLevel",
    "connectivityQuality",
    "simStatus",
    "simNetwork",
    "networkProvider",
];

// Maps the asset list's column keys to the field groups of the deferred
// SearchAssetsDeferred query. Every other column reads the flat search index
// attributes of SearchAssets. The groups differ heavily in backend cost
// (networkInformation ~15-20s per page with connected assets), so both the
// table and the CSV export only request the groups whose columns are
// shown/exported. `withActions` has no column of its own here: the actions
// column is always shown in the table and never exported.
export const DEFERRED_COLUMN_FIELD_GROUPS: Record<
    string,
    "withPath" | "withNetworkInfo"
> = {
    location: "withPath",
    simStatus: "withNetworkInfo",
    simNetwork: "withNetworkInfo",
    networkProvider: "withNetworkInfo",
};

export interface DeferredFieldFlags {
    withActions: boolean;
    withPath: boolean;
    withNetworkInfo: boolean;
}

export const getDeferredFieldFlags = (
    visibleFields: string[],
    withActions = false
): DeferredFieldFlags => {
    const flags: DeferredFieldFlags = {
        withActions,
        withPath: false,
        withNetworkInfo: false,
    };
    visibleFields.forEach((field) => {
        const group = DEFERRED_COLUMN_FIELD_GROUPS[field];
        if (group) flags[group] = true;
    });
    return flags;
};

export const hasAnyDeferredFlag = (flags: DeferredFieldFlags): boolean =>
    flags.withActions || flags.withPath || flags.withNetworkInfo;
